import React from "react";
import { ProductDraftContentImage } from "../../../../../lib/interface/InterfaceProduct";

export function PhotoColorListEditor({
  images,
  colors,
  onChange,
}: {
  images: ProductDraftContentImage[];
  colors: string[];
  onChange: (v: ProductDraftContentImage[]) => void;
}) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap" }}>
      {images.map((x, idx) => (
        <PhotoColorItem
          key={x.src}
          colors={colors}
          image={x}
          onChange={(v) => {
            const tmp = [...images];
            tmp[idx] = v;
            onChange(tmp);
          }}
        />
      ))}
    </div>
  );
}

export function PhotoColorItem({
  image,
  colors,
  onChange,
}: {
  image: ProductDraftContentImage;
  colors: string[];
  onChange: (v: ProductDraftContentImage) => void;
}) {
  return (
    <div
      style={{
        width: "auto",
        height: "auto",
        padding: 5,
        boxShadow: "0 4px 8px 0 #00000033, 0 6px 20px 0 #00000030",
        borderRadius: 2,
        marginRight: 20,
        marginBottom: 20,
      }}
    >
      <img
        src={"https:" + image.src}
        alt=""
        style={{
          width: 200,
          height: 200,
          marginBottom: 10,
          borderRadius: 2,
        }}
      />
      <br />
      <select
        className="form-control"
        style={{ borderRadius: 2 }}
        value={image.color}
        onChange={(e) => {
          onChange({
            src: image.src,
            color: e.currentTarget.value,
          });
        }}
      >
        <option value="">Not Assigned Color</option>
        {colors.map((x: string) => (
          <option value={x.toUpperCase()} key={x.toUpperCase()}>
            {x.toUpperCase()}
          </option>
        ))}
      </select>
    </div>
  );
}
